import { useSnackbarStore } from '../stores/snackbar'
import { defineNuxtPlugin } from '#app'
import { useLogger } from '#layers/base/composables/useLogger'

export default defineNuxtPlugin((nuxtApp) => {
  const log = useLogger()
  const store = useSnackbarStore()
  nuxtApp.vueApp.config.errorHandler = (error: any, context: any) => {
    log.error(error.message ?? 'ERROR CATCHED', { type: 'ERROR_PLUGIN', error, context })
    store.showMessage({ timeout: 10_000, text: error as string, color: 'error' })
  }
})
